import { render, staticRenderFns } from "./demands.vue?vue&type=template&id=2ff023f2"
import script from "./demands.vue?vue&type=script&lang=js"
export * from "./demands.vue?vue&type=script&lang=js"
import style0 from "./demands.vue?vue&type=style&index=0&id=2ff023f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports